export default "__VITE_ASSET__B_UqNk2X__"